import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";
import { Grid } from "@material-ui/core";



const TableTrilhaDn = ( { data, titulo, link=false, params=false }) => {

  const handleClickName = (e, nome_dr) => {
    e.preventDefault();   
    window.open(`${link}/${nome_dr}`, '_blank');
  };

  return (
    <TableContainer
      component={Paper}
      style={{
        border: "1px solid rgba(0, 0, 0, .125)",
        borderRadius: "10px",
        marginTop: "1rem"
      }}
    >
      <Table
        size="small"
        style={{
          width: "100%",
          borderRadius: "5px"
        }}
      >
        <TableHead style={{ borderRadius: "10px", backgroundColor: "#DADADA" }}>
          <TableRow>
            <TableCell
              align={"center"}
              style={{
                border: "1px solid rgba(0, 0, 0, .125)",
                borderRadius: "8px 0 0 10px"
              }}
            >
              {titulo}
            </TableCell>
            {data.map((category) => (
              <TableCell
                align={"center"}
                key={category.name}
                style={{
                  borderRadius: "0",
                  border: "1px solid rgba(0, 0, 0, .125)",
                }}
              >
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    {category.name}
                  </Grid>
                  <Grid item xs={12}>
                  </Grid>
                </Grid>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data[0] && data[0].data.map((item, i) => (
            <TableRow
              key={item[0]}
              style={{
                backgroundColor: i % 2 === 0 ? "#ededed" : "#f7f7f7",
                borderRadius: "0"
              }}
            >
              <TableCell
                component="th"
                scope="row"
                align={"center"}
                style={{
                  borderRadius: "0",
                  border: "1px solid rgba(0, 0, 0, .125)",
                }}
              >
                {
                link ?<Link
                  to={link}
                  onClick={(e) => {
                    if(titulo!='Escolas'){
                      handleClickName(e,item[0])
                    }else{
                      handleClickName(e,item[1])
                    }
                  }}
                >
                  {item[0]}
                </Link>:
                item[0]
                }
              </TableCell>
              {data.map((category) => (
                <TableCell
                  key={category.name}
                  align={"center"}
                  style={{
                    border: "1px solid rgba(0, 0, 0, .125)",
                  }}
                >
                  {category.data[i][1]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableTrilhaDn;
